{
  "hero": {
    "loading": "Inhalt wird geladen...",
    "headline": {
      "line1": "Strategischer Content für Unternehmen.",
      "line2": "Effizienz und Professionalität im digitalen Marketing"
    },
    "subheadline": "Technologie, Design und Videografie kommen zusammen, um echte Probleme zu lösen",
    "primaryCta": "Projekte ansehen",
    "secondaryCta": "Strategiesitzung in Timișoara buchen"
  },
  "hook": "Die Investition in Videoinhalte ist nicht nur ein Trend – es ist ein strategischer Schritt, um Ihr Unternehmen zu entwickeln und in dem heutigen wettbewerbsintensiven Markt die Nase vorn zu haben.",
  "industry": {
    "title": "Medienlösungen für Ihre Branche",
    "options": {
      "ecommerce": "E-Commerce Unternehmen",
      "restaurants": "Restaurants & Cafés",
      "retail": "Einzelhandel",
      "salons": "Salons & Spas",
      "fitness": "Fitnesscenter & Studios",
      "realestate": "Immobilienmakler",
      "professional": "Professionelle Dienste",
      "homeservices": "Haushaltsdienste"
    }
  },
  "problem": {
    "heading": "Warum die meisten digitalen Projekte nicht ankommen.",
    "copy": "Sie engagieren einen Entwickler für Code, einen Designer für ein Logo und einen Videografen für Content. Das Ergebnis? Eine fragmentierte Marke, die sich zusammenhanglos anfühlt. Ich habe zwei Jahrzehnte lang gesehen, wie Websites mit großartigem Code, aber 'hohlem' Content starteten. Khromatik wurde gebaut, um das zu beheben."
  },
  "pillars": {
    "architect": {
      "title": "Der Architekt",
      "subtitle": "Beratung",
      "description": "UI/UX-Audits und Frontend-Architektur für komplexe Plattformen. Expertise auf Senior-Ebene für große Herausforderungen."
    },
    "builder": {
      "title": "Der Erbauer",
      "subtitle": "Entwicklung",
      "description": "Maßgeschneiderte Markenidentitäten und hochgeschwindigkeits Websites, die Besucher tatsächlich in Kunden verwandeln."
    },
    "storyteller": {
      "title": "Der Geschichtenerzähler",
      "subtitle": "Content",
      "description": "Kinematische Videos und Fotografie, vor Ort in Timișoara gedreht, um Ihrer Technik eine menschliche Seele zu geben."
    }
  },
  "holisticEdge": {
    "heading": "Eine klare Vision. Flüssige Umsetzung.",
    "workflow": {
      "strategy": "Strategie",
      "design": "Design",
      "code": "Code",
      "content": "Content",
      "launch": "Launch"
    },
    "valueProposition": "Weil ich das Video drehe und den Code schreibe, ist Ihre Website um Ihre Geschichte herum gestaltet, nicht umgekehrt."
  },
  "socialProof": {
    "heading": "Seit 20 Jahren vertrauenswürdig",
    "recommendations": {
      "heading": "Empfehlungen"
    },
    "companies": [
      "2trde",
      "Testbirds",
      "GitDigest",
      "HireMeMate",
      "Polestar"
    ],
    "featuredProject": {
      "title": "Empfohlenes Projekt",
      "projectTitle": "Polestar-Partnerschafts-Launch",
      "description": "Eine komplette Kampagne, bei der ich das Branding, die Website und das Video aus einer Vision heraus betreut habe.",
      "cta": "Fallstudie ansehen"
    }
  },
  "localPresence": {
    "heading": "Hochwertige Qualität, lokal geliefert",
    "copy": "Mit Sitz in Timișoara biete ich Qualität auf westlichem Marktniveau mit dem Vorteil einer lokalen, persönlichen Partnerschaft. Ob es ein Content-Tag in Ihrem Büro in Arad oder ein UI-Workshop im Herzen von Timișoara ist, ich bin Ihre kreative Abteilung auf Abruf."
  },
  "packages": {
    "heading": "Wählen Sie Ihren Weg",
    "audit": {
      "title": "Das Audit",
      "description": "Schneller Erfolg für große Unternehmen. UI/UX-Audit und strategische Empfehlungen.",
      "cta": "Mehr erfahren"
    },
    "launch": {
      "title": "Der Launch",
      "description": "Für neue Marken. Komplette digitale Identität von der Konzeption bis zum Launch.",
      "cta": "Mehr erfahren"
    },
    "partnership": {
      "title": "Die Partnerschaft",
      "description": "Monatlicher Content-Retainer. Laufende Unterstützung für wachsende Unternehmen.",
      "cta": "Mehr erfahren"
    }
  },
  "footerCta": {
    "heading": "Bereit, Ihre digitale Präsenz zu vereinheitlichen?",
    "contactText": "Lassen Sie uns über Ihr Projekt sprechen",
    "bookSession": "Strategiesitzung buchen",
    "or": "oder",
    "contactLink": "Kontakt aufnehmen"
  }
}
